<ng-template #listTemplate let-visibleAdmins>
  <div
    *ngFor="let admin of visibleAdmins; trackBy: trackById"
    class="result"
    [class.disabled]="disabledIds[admin.id]"
  >
    <rt-group variant="horizontal" (click)="toggleAssignment(admin)">
      <span
        [rtTooltip]="disabledIds[admin.id] && lockedAssignmentsTooltip"
        [rtTooltipMaxWidth]="245"
        [rtTooltipHasTextAlignCenter]="true"
      >
        <rt-checkbox
          [disabled]="disabledIds[admin.id]"
          [value]="$any(admin.id)"
          [checked]="selectedIds.has(admin.id)"
          (click)="toggleAssignment(admin)"
        >
        </rt-checkbox>
      </span>
      <rt-avatar
        [type]="admin.hasAvatar ? 'image' : 'initials'"
        [initials]="admin.initials"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="admin.photoThumbUrl"
        context="admin"
      ></rt-avatar>
      <div margin-left-small layout-vertical>
        <rt-heading>{{ admin.firstName }} {{ admin.lastName }}</rt-heading>
        <span>{{ admin.email }}</span>
      </div>
    </rt-group>
    <rt-divider></rt-divider>
  </div>
</ng-template>

<ng-template #disabledListTemplate let-visibleAdmins>
  <div *ngFor="let admin of visibleAdmins; trackBy: trackById" class="result">
    <rt-group
      variant="horizontal"
      [rtTooltip]="'app.candidate.admin_select.no_access.tooltip' | translate"
      [rtTooltipMaxWidth]="260"
      rtTooltipPosition="left"
    >
      <rt-checkbox [disabled]="true" />
      <rt-avatar
        [type]="admin.hasAvatar ? 'image' : 'initials'"
        [initials]="admin.initials"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="admin.photoThumbUrl"
        context="admin"
      ></rt-avatar>
      <div class="admin-info" margin-left-small layout-vertical>
        <span class="heading">{{ admin.firstName }} {{ admin.lastName }}</span>
        <span>{{ admin.email }}</span>
      </div>
    </rt-group>
    <rt-divider></rt-divider>
  </div>
</ng-template>

<rt-dialog-header
  [heading]="heading"
  [subheading]="showCountBeforeSubheading ? selectedIds.size + ' ' + subheading : subheading"
>
</rt-dialog-header>

<rt-dialog-body>
  <rt-spinner *ngIf="loadingAdmins"></rt-spinner>

  <rt-box *ngIf="!loadingAdmins" variant="vertical background no-padding">
    <div class="search">
      <rt-form-field>
        <rt-input
          variant="rounded"
          [placeholder]="'app.common.placeholders.search.team_members.other' | translate"
          [autoFocus]="true"
          [formControl]="searchControl"
          [hasClearButton]="true"
          (reset)="cancelSearch()"
        >
          <rt-icon prefix name="search"></rt-icon>
        </rt-input>
      </rt-form-field>

      <rt-group variant="horizontal" class="select-options">
        <rt-button variant="plain" (click)="selectAll()">
          {{ 'app.common.all' | translate }}
        </rt-button>
        <rt-button variant="plain" (click)="selectNone()">
          {{ 'app.common.none' | translate }}
        </rt-button>
      </rt-group>
    </div>

    <rt-divider variant="line"></rt-divider>

    <ng-container *ngIf="filteredAdmins.length">
      <div
        *ngIf="filteredAdmins.length > 20"
        class="results results--virtual"
        virtualScroller
        [items]="filteredAdmins"
        [bufferAmount]="10"
        [scrollAnimationTime]="0"
        [scrollThrottlingTime]="10"
        [executeRefreshOutsideAngularZone]="true"
        (vsUpdate)="onVirtualScrollUpdate($event)"
      >
        <ng-template
          [ngTemplateOutlet]="listTemplate"
          [ngTemplateOutletContext]="{ $implicit: virtualScrollAdmins }"
        ></ng-template>
      </div>
      <div *ngIf="filteredAdmins.length <= 20 && filteredAdmins.length > 0" class="results">
        <ng-template
          [ngTemplateOutlet]="listTemplate"
          [ngTemplateOutletContext]="{ $implicit: filteredAdmins }"
        ></ng-template>
      </div>
    </ng-container>
    <ng-container *ngIf="filteredDisallowedAdmins.length">
      <div class="header">
        {{ 'app.candidate.admin_select.no_access.header' | translate }}
      </div>
      <div
        *ngIf="filteredDisallowedAdmins.length > 20"
        class="results results__disabled results--virtual"
        virtualScroller
        [items]="filteredDisallowedAdmins"
        [bufferAmount]="10"
        [scrollAnimationTime]="0"
        [scrollThrottlingTime]="10"
        [executeRefreshOutsideAngularZone]="true"
        (vsUpdate)="onVirtualScrollUpdateForDisabled($event)"
      >
        <ng-template
          [ngTemplateOutlet]="listTemplate"
          [ngTemplateOutletContext]="{ $implicit: virtualScrollDisabledAdmins }"
        ></ng-template>
      </div>
      <div *ngIf="filteredDisallowedAdmins.length <= 20" class="results results__disabled">
        <ng-template
          [ngTemplateOutlet]="disabledListTemplate"
          [ngTemplateOutletContext]="{ $implicit: filteredDisallowedAdmins }"
        ></ng-template>
      </div>
    </ng-container>
    <rt-empty-state
      *ngIf="!filteredAdmins.length && !filteredDisallowedAdmins.length"
      variant="small"
      [icon]="'search'"
      [title]="'app.common.no_results_found' | translate"
    >
      <rt-button variant="secondary" (click)="cancelSearch()">
        {{ 'app.assignments.editor.clear_search' | translate }}
      </rt-button>
    </rt-empty-state>
  </rt-box>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button *ngIf="!loading" variant="plain" (click)="cancel()">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button variant="primary" [disabled]="!isValid()" [loading]="loading" (click)="submit()">
    {{ 'app.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
